import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AuthService } from "app/core/auth/auth.service";
import { UserService } from "app/core/user/user.service";
import { User } from "app/core/user/user.types";
import { Observable, throwError, timer, of } from "rxjs";
import { retry, catchError, timeout, finalize } from "rxjs/operators";

@Injectable({providedIn: 'root'})

export class onBoardingService{

    // private _authService = inject(AuthService);

    // apiOnBoardingUrl = 'http://localhost:3000/onboarding';
    apiOnBoardingUrl = 'https://apibea.azurewebsites.net/api';
    apiBeAmbassador = 'https://api.be-ambassador.com/api';
    apiBeAmbassadorV2 = 'https://apibea-v2-preview.azurewebsites.net/api/v2';
    apiUploadFile = '/azure/uploadfile';
    apiTUCUrl = '/profiles/UTCList';
    apiCountryUrl = '/tools/CountriesList';
    apiCategoriesUrl = '/tools/CategoriesList';
    apiKPI = '/onboarding/KPIList';
    private token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqb25heUBzdXBwb3J0Ymxncy5jb20iLCJlbWFpbCI6ImpvbmF5QHN1cHBvcnRibGdzLmNvbSIsImp0aSI6IjRkZTI4NWFkLWU5YmMtNDUxYy04NDJmLWRiMzJkMDdmMDFjYSIsIm5iZiI6MTc0MjI5NDU1MiwiaWF0IjoiMy8xOC8yMDI1IDEwOjQyOjMyIEFNIiwiZXhwIjoxODM2OTAyNTUyLCJpc3MiOiJodHRwczovL2FwaWJlYS1wcmV2aWV3LmF6dXJld2Vic2l0ZXMubmV0IiwiYXVkIjoiaHR0cHM6Ly9hcGliZWEtcHJldmlldy5henVyZXdlYnNpdGVzLm5ldCJ9.ljx7cEl74v4QLFrKXgZ1U8DIikdUpG1u99Pl9EViPWk'; // Reemplaza con tu token
    // private token = this._authService.accessToken;
    
    // userGUID = '15475842-670f-4a63-8485-efed31c0517c';
    // apiKey = '9FEB3227-B92E-4825-B1DD-A50E3A60A67A';
    apiKey;
    onboardingId;
    constructor( private http: HttpClient,
                 private _userService: UserService,
    ) {
        this._userService.user$.subscribe((user: User) => {
            this.onboardingId = user.guid;
            this.apiKey = user.apiKey;
            return user.guid});
    }
    
    /**
     * Retorna el GUID del usuario actual
     * @returns string - El GUID del usuario o una cadena vacía si no está disponible
     */
    getUserGUID(): string {
        return this.onboardingId || '';
    }
    
    /**
     * Retorna el API Key del usuario actual
     * @returns string - El API Key del usuario o una cadena vacía si no está disponible
     */
    getApiKey(): string {
        return this.apiKey || '';
    }

    List(): Observable<any> {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${this.token}`,
            'apikey': `${this.apiKey}`,
            'appkey': '34B57314-AEA4-4298-9935-199010D97DF1',
            'Content-Type': 'application/json',
            // 'Cookie': 'ARRAffinity=117e990d40d4c16939755b30c0bfe53bff82d13d78c21a472fef7dbf8d0d0ea0; ARRAffinitySameSite=117e990d40d4c16939755b30c0bfe53bff82d13d78c21a472fef7dbf8d0d0ea0'
        });
        return this.http.get(`${this.apiBeAmbassadorV2}/onboarding/List?guid=${this.onboardingId}`, { headers }); // List ?guid= ${this.userGUID}
    }

    Save(onBoardingList: any): Observable<any> {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${this.token}`,
            'apikey': `${this.apiKey}`,
            'appkey': '34B57314-AEA4-4298-9935-199010D97DF1',
            'Content-Type': 'application/json',
            // 'Cookie': 'ARRAffinity=117e990d40d4c16939755b30c0bfe53bff82d13d78c21a472fef7dbf8d0d0ea0; ARRAffinitySameSite=117e990d40d4c16939755b30c0bfe53bff82d13d78c21a472fef7dbf8d0d0ea0'
        });
        return this.http.post(`${this.apiBeAmbassadorV2}/onboarding/Save?guid=${this.onboardingId}`, onBoardingList, { headers });
    }

    getCountries(): Observable<any> {
        const headers = this.getHeaders();
        return this.http.get(`${this.apiBeAmbassadorV2}${this.apiCountryUrl}`, { headers });
    }

    getCategoriesList(){
        const headers = this.getHeaders();
        return this.http.get(`${this.apiBeAmbassadorV2}${this.apiCategoriesUrl}`, { headers });
    }

    // Método para obtener la lista de zonas horarias
    getTimeZones(): Observable<any> {
        const headers = this.getHeaders();
        return this.http.get(`${this.apiBeAmbassadorV2}${this.apiTUCUrl}`, { headers });
    }

    uploadFile(file: any): Observable<any>{
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${this.token}`,
            'apikey': `${this.apiKey}`,
            'appkey': '34B57314-AEA4-4298-9935-199010D97DF1',
            // 'Content-Type': 'multipart/form-data',
        });
        if (file.name.includes(" ")) {
            const newFile = new File([file], file.name.replace(/ /g, "-"), {
                type: file.type,
                lastModified: file.lastModified,
            });
            file = newFile;
        }
        try{
            const formData = new FormData();
            formData.append("file", file);
            return this.http.post(`${this.apiBeAmbassadorV2}${this.apiUploadFile}`,formData , { headers });
        } catch(ex){
            console.error(ex);
        }
    }

    // Método privado para generar los headers
    private getHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Authorization': `Bearer ${this.token}`,
            'apikey': `${this.apiKey}`,
            'appkey': '34B57314-AEA4-4298-9935-199010D97DF1',
            'Content-Type': 'application/json',
        });
    }

    getVideoAvatarList(): Observable<any> {
        const headers = this.getHeaders();
        return this.http.get(`${this.apiBeAmbassadorV2}/onboarding/VideoAvatarList`, { headers });
    }

    getKpis(): Observable<any[]> {
        const headers = this.getHeaders();
        
        return this.http.get<any[]>(`${this.apiBeAmbassadorV2}${this.apiKPI}`, { headers })
            .pipe(
                timeout(10000), // 10 segundos de timeout para la petición
                retry({ count: 2, delay: (error, retryCount) => {
                    return timer(1000); // Espera 1 segundo antes de reintentar
                }}),
                catchError((error: HttpErrorResponse) => {
                    console.error('Error al obtener KPIs de la API:', error);
                    return throwError(() => new Error('No se pudieron cargar los KPIs. Por favor, intenta más tarde.'));
                }),
                finalize(() => {})
            );
    }

    recoveryPassword(usermail: string): Observable<any> {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${this.token}`,
            'apikey': `${this.apiKey}`,
            'appkey': '34B57314-AEA4-4298-9935-199010D97DF1',
            'Content-Type': 'application/json',
            'Cookie': 'ARRAffinity=c8ec39318721945ffbb4c58dce2918687224172905b46e67f4b4f26f95df8b8f; ARRAffinitySameSite=c8ec39318721945ffbb4c58dce2918687224172905b46e67f4b4f26f95df8b8f'
        });
        return this.http.post(`${this.apiBeAmbassadorV2}/account/RecoveryAccountPassword`, { usermail }, { headers });
    }
    finishProject(): Observable<any> {
        const headers = this.getHeaders();
        // Passing onboardingId as a proper JSON object in the request body
        const body = { onboardingId: this.onboardingId };
        return this.http.post(`${this.apiBeAmbassadorV2}/onboarding/FinishProject`, body, { headers });
    }

    projectStatus(): Observable<any> {
        const headers = this.getHeaders();
        
        // Using a query parameter instead of a body for GET request
        return this.http.get(`${this.apiBeAmbassadorV2}/onboarding/ProjectStatus?onboardingId=${this.onboardingId}`, { 
            headers: headers 
        }).pipe(
            catchError((error: HttpErrorResponse) => {
                console.error('Error getting project status:', error);
                return throwError(() => new Error('Unable to retrieve project status. Please try again later.'));
            })
        );
    }
    finishProjectLog(): Observable<any> {
         const headers = this.getHeaders();
         return this.http.request('GET', `${this.apiBeAmbassadorV2}/onboarding/FinishProjectLog?onboardingId=${this.onboardingId}`, {
             headers: headers});
     }
 }
